import { register } from "@shopify/theme-sections";

register("article", {
  initShare() {
    const btn = document.querySelector(".share-button__button-mobile");
    if (btn) {
      const btnTitle = btn?.dataset.title;
      const btnUrl = btn?.dataset.url;
      const shareData = {
        title: btnTitle,
        url: btnUrl,
      };
      btn.addEventListener("click", async () => {
        try {
          await navigator.share(shareData);
        } catch (err) {
          console.log("Error", err);
        }
      });
    }
  },

  initCopy() {
    const copyButton = document.querySelector(".share-button__copy");
    function handleCopyText() {
      const cb = navigator.clipboard;
      const paragraph = document.querySelector(".field__input");
      cb.writeText(paragraph.value).then(() => console.log("Text copied"));
    }
    if (copyButton) {
      copyButton.onclick = () => {
        handleCopyText();
      };
    }
  },

  onLoad: function (e) {
    this.initShare();
    this.initCopy();
  },
});
